import * as React from 'react'

import { theme } from '@factorialco/deprecated-design-system'

import Chip from 'modules/core/components/Filter/base/Chip'
import ClearValue from 'modules/core/components/Filter/base/ClearValue'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

import getTitle from 'modules/documents/components/Documents/getTitle'
import FolderSelector from 'modules/documents/components/Folders/FolderSelector'
import { Folder } from 'modules/documents/hooks/useGetFolders'

const NO_FOLDER_FILTER_ID = -1

type Props = {
  header: React.ReactNode
  label: string
  value: number
  options: Folder[]
  onValueChange: (value?: number) => void
  defaultOpen?: boolean
}

function Body({
  selectedFolder,
  folders,
}: {
  selectedFolder: Folder | undefined
  folders: Folder[]
}) {
  const { onValueChange } = useFilter()

  const onChange = (selectedFolderId: number | null) => {
    onValueChange(selectedFolderId ? selectedFolderId : NO_FOLDER_FILTER_ID)
  }

  return (
    <FolderSelector
      folders={folders}
      label={i18n.t('split_documents.form.select_label')}
      onChange={(selectedOption) => onChange(selectedOption)}
      initialFolder={selectedFolder}
      hideSelectInput
    />
  )
}

function FolderChoice({ header, onValueChange, label, options, value, defaultOpen }: Props) {
  const selectedFolder = options.find((f) => f.id === value)
  const selectedFolderLabel = selectedFolder
    ? getTitle(selectedFolder.name)
    : i18n.t('split_documents.form.none')

  return (
    <Provider value={value} onValueChange={onValueChange} defaultOpen={!!defaultOpen}>
      <Chip.Toggler
        active={!!selectedFolderLabel}
        label={label}
        activeLabel={selectedFolderLabel}
      />
      <Content
        header={header}
        body={<Body selectedFolder={selectedFolder} folders={options} />}
        footer={<ClearValue />}
        maxHeight={theme.dimensions.s600}
      />
    </Provider>
  )
}

export default FolderChoice
